import React, { useState } from "react";
import { Save } from "lucide-react";

const inputCls = "w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#4563BB]";

export const Field = ({ label, value, onChange, multiline = false, testId, placeholder }) => (
  <label className="block space-y-1">
    <span className="text-xs font-semibold text-slate-600">{label}</span>
    {multiline ? (
      <textarea rows={4} value={value || ""} onChange={(e) => onChange(e.target.value)} className={inputCls} data-testid={testId} placeholder={placeholder} />
    ) : (
      <input value={value || ""} onChange={(e) => onChange(e.target.value)} className={inputCls} data-testid={testId} placeholder={placeholder} />
    )}
  </label>
);

export const Card = ({ title, children, testId }) => (
  <section className="rounded-xl bg-white border border-slate-200 p-5 space-y-4" data-testid={testId}>
    <h2 className="text-sm font-bold text-slate-900">{title}</h2>
    {children}
  </section>
);

export const SaveBtn = ({ onClick, busy, testId }) => (
  <button type="button" onClick={onClick} disabled={busy} data-testid={testId}
    className="inline-flex items-center gap-2 rounded-lg bg-[#4563BB] hover:opacity-90 disabled:opacity-50 text-white text-sm font-semibold px-4 py-2">
    <Save className="w-4 h-4" /> Speichern
  </button>
);

// Bearbeitbarer Block (Objekt mit Feldern) mit eigenem Speichern-Knopf.
export const ObjectEditor = ({ title, value, fields, onSave, testId }) => {
  const [draft, setDraft] = useState(value);
  const [busy, setBusy] = useState(false);
  const save = async () => { setBusy(true); try { await onSave(draft); } finally { setBusy(false); } };
  return (
    <Card title={title} testId={testId}>
      {fields.map(([key, label, multiline]) => (
        <Field key={key} label={label} value={draft[key]} multiline={multiline}
          onChange={(v) => setDraft({ ...draft, [key]: v })} testId={`${testId}-${key}`} />
      ))}
      <SaveBtn onClick={save} busy={busy} testId={`${testId}-save`} />
    </Card>
  );
};

const STATUS_LABEL = { draft: "Entwurf (nur Testkonten)", active: "Aktiv", paused: "Pausiert", ended: "Beendet" };

export const StatusCard = ({ cfg, onSave }) => (
  <Card title="Status" testId="ch2-status-card">
    <div className="flex flex-wrap gap-2">
      {Object.entries(STATUS_LABEL).map(([k, l]) => (
        <button key={k} type="button" onClick={() => onSave({ status: k })} data-testid={`ch2-status-${k}`}
          className={`rounded-full px-4 py-2 text-sm font-semibold border ${cfg.status === k ? "bg-[#0F172A] text-white border-[#0F172A]" : "bg-white text-slate-700 border-slate-300 hover:border-slate-500"}`}>
          {l}
        </button>
      ))}
    </div>
    <label className="flex items-center gap-3 text-sm">
      <input type="checkbox" checked={!!cfg.allow_new} onChange={(e) => onSave({ allow_new: e.target.checked })} data-testid="ch2-allow-new" className="w-4 h-4" />
      Neue Teilnehmer zulassen (gilt nur im Status „Aktiv“)
    </label>
    <p className="text-xs text-slate-500" data-testid="ch2-status-hint">
      Entwurf: nur Testadressen können einsteigen. Pausiert: keine neuen Teilnehmer, Freischaltung angehalten. Beendet: keine neuen Teilnehmer, Inhalte bleiben lesbar.
    </p>
  </Card>
);
